<template lang="pug">
  v-content
    v-container.grey.lighten-4
      v-row
        v-col
          pageTitle(text="銀行口座一覧") 銀行口座一覧
    v-container.grey.lighten-5
      v-data-table.elevation-1(
        :headers="headers", :items="bank_accounts", item-key="id"
      )
        template(v-slot:top)
          v-toolbar(flat color="white")
            v-toolbar-title 銀行口座
            v-divider.mx-4(insert vertical)
            v-spacer
            v-dialog(v-model="edit_dialog" max-width="500px")
              template(v-slot:activator="{ on }")
                v-btn.mb-2(color="primary" dark v-on="on") 新規作成
              v-card
                v-card-title
                  span.headline {{ formTitle }}
                v-card-text
                  v-container
                    v-card(v-if="errors.length")
                      v-card-text
                        v-list-item(v-for="error in (errors)" dense  :v-key="error")
                          v-list-item {{ error }}
                      v-card-actions
                        v-btn(color="blue" text @click="closeErrD") 閉じる
                    v-row
                      v-col(cols="12" sm="6" md="4")
                        v-text-field(v-model="current_ba.bank_name" label="銀行名")
                      v-col(cols="12" sm="6" md="4")
                        v-text-field(v-model="current_ba.branch" label="支店名")
                      v-col(cols="12" sm="6" md="4")
                        v-select(v-model="current_ba.account_type" label="口座種別" :items="actypes")
                      v-col(cols="12" sm="6" md="4")
                        v-text-field(v-model="current_ba.account_number" label="口座番号")
                v-card-actions
                  v-btn(color="blue darken-1" text @click='edit_save') 保存
                  v-spacer
                  v-btn(color="blue darken-1" text @click='edit_cancel') キャンセル
        template(v-slot:item.account_type="{item}") {{ account_type2str(item) }}
        template(v-slot:item.action="{item}")
          v-icon.mr-2(small @click="edit_item(item)") mdi-pencil
    v-snackbar(v-model="sb.disp" :timeout="sb.timeout") {{ sb.text }}
      v-btn(color="blue" text @click="sb.disp=false") 閉じる
</template>

<script>
  // 銀行口座一覧ページ
  // todo: 登録・編集ダイアログの field に rules を追加する。
  import debugLog from '@/utils/debugLog'
  import { getBankAccounts, postBankAcount, patchBankAcount } from '@/api/bank_account'
  import pageTitle from '@/components/pageTitle'

  export default {
    name: 'BankAccount',
    data() { return {
      edit_dialog: false,
      headers: [
        {text: 'ID', value: 'id'},
        {text: '銀行名', value: 'bank_name'},
        {text: '支店', value: 'branch'},
        {text: '口座種別', value: 'account_type'},
        {text: '口座番号', value: 'account_number'},
        {text: '　', value: 'action', sortable: false}
      ],
      bank_accounts: [],
      editedIndex: -1,
      current_ba: {},
      actypes: [{text: '普通', value: 1}, {text: '当座', value: 2}, {text: 'ゆうちょ', value: 3}],
      defaultItem: {id: '', bank_name: '', branch: '', account_type: '', account_number: ''},
      sb: { disp: false, text: '', timeout: 1500 },
      errors: {}
    }},
    components: {pageTitle},
    created() {
      this.getRecords()
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? '新規作成' : '編集'
      },
    },
    watch: {
      edit_dialog (val) {
        val || this.edit_cancel()
      },
    },
    methods: {
      getRecords() {
        const self = this
        getBankAccounts(null).then((res) => {
          // debugLog(res)
          self.bank_accounts = Object.assign([], res.data.data)
        })
      },
      edit_item(item) {
        this.editedIndex = this.bank_accounts.indexOf(item)
        this.current_ba = Object.assign({}, item)
        this.edit_dialog = true
      },
      account_type2str(item) {
        const a = ['', '普通', '当座', 'ゆうちょ']
        return a[item.account_type]
      },
      edit_save() {
        if (this.current_ba.id) {
          patchBankAcount(this.current_ba).then((res) => {
            debugLog(res)
            this.sb.text = '更新しました'
            this.sb.disp = true
            this.edit_cancel()
            this.getRecords()
          }, err => {
            this.disp_error(err)
          })
        } else {
          postBankAcount(this.current_ba).then((res) => {
            debugLog(res)
            this.sb.text = '新規登録しました'
            this.sb.disp = true
            this.edit_cancel()
            this.getRecords()
          }, err => {
            this.disp_error(err)
          })
        }
      },
      edit_cancel() {
        this.edit_dialog = false
        setTimeout(() => {
          this.current_ba = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      disp_error(error) {
        debugLog(error)
        let errs = []
        let keys = error.data
        for (let key in keys)
          errs.push(key + ' ' + error.data[key])
        this.errors = errs
      },
      closeErrD() {
        this.errors = []
      }
    }
  }
</script>
